




























































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import services from "@/services";
import { WorkspaceDto } from "@/application/dtos/app/workspaces/WorkspaceDto";

@Component({
  components: {}
})
export default class WorkspaceSelect extends Vue {
  @Prop() tenantId!: string;
  @Prop({ default: true }) selectAll!: boolean;
  @Prop({ default: "" }) preSelect!: string;
  public selected: number = -1;
  private dropDown: boolean = false;
  private items: WorkspaceDto[] = [];
  private loading: boolean = false;
  mounted() {
    this.loading = true;
    services.workspaces
      .getAllWorkspaces()
      .then((response: WorkspaceDto[]) => {
        this.items = response;
        if (this.selectAll) {
          this.selected = 0;
        }
        if (this.preSelect) {
          this.selectId(this.preSelect);
        }
      })
      .catch(() => {
        // ignore
      })
      .finally(() => {
        this.loading = false;
      });
  }
  select(idx) {
    this.selected = idx;
    this.dropDown = false;
    if (this.selectedCompany) {
      this.$emit("selectWorkspace", this.selectedCompany.id);
    } else {
      this.$emit("selectAllWorkspaces");
    }
  }
  selectId(id: string) {
    const idx = this.items.findIndex(f => f.id === id);
    if (idx !== -1) {
      this.selected = idx + 1;
    }
  }
  closeDropDown() {
    this.dropDown = false;
  }
  get selectedCompany(): WorkspaceDto | undefined {
    if (this.selected > 0) {
      return this.items[this.selected - 1];
    }
  }
}
